import { render, staticRenderFns } from "./addzoneCommunityPosts.vue?vue&type=template&id=3f66d05e&scoped=true"
import script from "./addzoneCommunityPosts.vue?vue&type=script&lang=js"
export * from "./addzoneCommunityPosts.vue?vue&type=script&lang=js"
import style0 from "./addzoneCommunityPosts.vue?vue&type=style&index=0&id=3f66d05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66d05e",
  null
  
)

export default component.exports